import jwtDecode from "jwt-decode";
import apiConfig from "../config/api";
import { get, post, requestDelete, put_av2, requestDelete_av2 } from "../helpers/request";

const autoasignApi = `${apiConfig.apiUri}api/accessmanagement/selfassignment`;
const autoasignApiAV2 = `${apiConfig.apiUriAV2}api/admin/v1/gestion-usuarios/usuarios/`;
//const autoasignApi = `${apiConfig.localUri}/accessmanagement/selfassignment`;

export const getAssignedCompanies = (params) => get(`${autoasignApi}/get/contact`, { params });

export const getAllCompanies = (params) => get(`${autoasignApi}/get/companies/contact`, { params });

export const assignCompany = (companies) =>
  post(`${autoasignApi}/create/contact`, {
    body: JSON.stringify({
      CompanyRuts: companies,
    }),
  });

export const deleteCompany = (companies) =>
  requestDelete(`${autoasignApi}/delete/contact`, {
    body: JSON.stringify({
      Assignments: companies,
    }),
  });

const WhoIsThere = () => {
  try{
    const rolesJWT = localStorage.getItem('roles-jwt');
    const roles = jwtDecode(rolesJWT).rolesData;
    if(roles.some(r => r.codigoRol === 'SUPERADMIN'))
      return 'SUPERADMIN'
    return roles.some(r => r.codigoRol === 'CONTACT_CENTER') ? 'CONTACT_CENTER': '';
  }catch(e){
    console.log(e)
  }
  
}

const getRolAutoasignado = () =>  WhoIsThere() ? `${WhoIsThere()}_AUTOASIGNADO`: ''

export const assignCompanyAV2 = (companies) => { // Debería ser posible agregar varias empresas al tiempo
  const autoasignacionRol = getRolAutoasignado()
  try{
    return put_av2(`${autoasignApiAV2}crear/rolautoasignado`,{
      body: JSON.stringify({
        entidad: companies,
        autoasignacionRol
      })
    })
  }catch(e){
    throw new Error()
  }
    
  
}

export const deleteCompanyAV2 = (companies) => {
  try{
    return requestDelete_av2(`${autoasignApiAV2}eliminar/autoasignado/empresa`, {
      body: JSON.stringify({
        entidad: companies
      })
    })
  }catch(e){
    throw new Error()
  }
  
}
  
